import { ApiError, Entitlement, getEntitlements } from "@blacknut/javascript-sdk/dist";
import { Dispatch } from "redux";
import { concatMap } from "rxjs";
import { UserAction, UserActionTypes, fetchSubscriptionSuccess } from "../User";
import { amazonSubscribeUpdate as apiAmazonSubscribeUpdate } from "@blacknut/javascript-sdk/dist/api/User/Action/amazonSubscribeUpdate";
import { ThunkDispatchType } from "core/redux/Store";

const userAmazonUpdateRequest = (): UserAction => ({
  type: UserActionTypes.USER_AMAZON_UPDATE_REQUEST,
});
const userAmazonUpdateSuccess = (entitlements: Entitlement[]): UserAction => ({
  type: UserActionTypes.USER_AMAZON_UPDATE_SUCCESS,
  entitlements,
});
const userAmazonUpdateError = (error?: ApiError): UserAction => ({
  type: UserActionTypes.USER_AMAZON_UPDATE_ERROR,
  error,
});

export const dismissAmazonSubscribeUpdateError = () => {
  return (dispatch: Dispatch<UserAction>) => {
    dispatch(userAmazonUpdateError());
  };
};
export const amazonSubscribeUpdate = (purchaseResponseJson: any) => {
  return (dispatch: ThunkDispatchType<UserAction>) => {
    return new Promise<Entitlement[]>((resolve, reject) => {
      dispatch(userAmazonUpdateRequest());

      apiAmazonSubscribeUpdate(purchaseResponseJson)
        .pipe(concatMap(() => getEntitlements()))
        .subscribe({
          next: (res) => {
            dispatch(userAmazonUpdateSuccess(res));
            dispatch(fetchSubscriptionSuccess(res));
            resolve(res);
          },
          error: (error) => {
            dispatch(userAmazonUpdateError(error));
            reject(error);
          },
        });
    });
  };
};
